<template>
  <div id="EdicionYAsignacion_div" class="w-100 px-5 py-4">
    <div id="TituloEdicionYAsignacion_div">
      <h1 style="margin-bottom: 0px;">Validación de la audiencia</h1>
      <h3 style="margin-top: 0px;">Verificación de las sesiones y permisos de descarga de la audiencia</h3>
    </div>
    <div class="row d-flex">
      <div id="DespliegueVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-3 padding-div-low">
        <div class="area">
          <h2>Información</h2>
          <hr />
          <p><strong>Juzgado: </strong><br />{{Audiencia.Area.Nombre}}</p>
          <p><strong>Materia: </strong><br />{{Audiencia.Materia.Nombre}}</p>
          <p><strong>Tipo de documento: </strong><br />{{Audiencia.TipoDocumento.Nombre}}</p>
          <p><strong>Consecutivo: </strong><br />{{Audiencia.Consecutivo}}</p>
          <p><strong>Tipo de audiencia: </strong><br />{{Audiencia.TipoAudiencia.Nombre}}</p>
          <p><strong>Fecha: </strong><br />{{Audiencia.FechaAudiencia}}</p>
          <p><strong>Sala: </strong><br />{{Audiencia.Sala.Nombre}}</p>
          <p><strong>Estatus de la audiencia: </strong><br />{{Audiencia.TipoEstatusDeAudiencia.Nombre}}</p>
        </div>
      </div>
      <div id="ContenidoVistaDeInformacion_div" class="col-12 col-sm-12 col-md-12 col-lg-9 padding-div-low">
        <div class="area">
          <h4>Detalles de la audiencia</h4>
          <h6>Verifique e ingrese los datos faltantes de la audiencia</h6>
          <hr />
          <component :is="componente" v-bind:AudienciaId="AudienciaId"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  //Importaciones estandarizadas
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import RouterForseti from '@/router/index'
  import detalles from '@/../src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/_Detalles.vue';

  export default {
    components: {
      Detalles: detalles,
      RouterForseti
    },
    data() {
      return {
        comun,
        enumeraciones,
        Audiencia: {
          AudienciaId: Number,
          Area: { Nombre: String },
          Materia: { Nombre: String },
          TipoAudiencia: {
            Nombre: String
          },
          TipoDocumento: {
            Nombre: String
          },
          Fecha: String,
          HoraDeInicio: String,
          HoraFinalizada: String,
          Jueces: [
            { Nombre: String }
          ],
          Sala: { Nombre: String },
          TipoEstatusDeAudiencia: {
            TipoEstatusDeAudienciaId: Number,
            Nombre: String
          }
        },
        componente: "Detalles"
      }
    },
    props: {
      AudienciaId: Number
    },
    mounted() {
      if (this.AudienciaId != null && this.AudienciaId != undefined && this.AudienciaId > 0) {
        this.busquedaAudiencia();
      } else {
        RouterForseti.push({
          name: 'PanelDeAudienciasPorVerificar'
        });
      }
    },
    methods: {
      busquedaAudiencia() {
        comun.SeEstaCargandoInformacion(true);
        let _this = this;

        let peticion = {
          AudienciaId: this.AudienciaId,
          BaseDeDatosProvenienteId: this.BaseDeDatosProvenienteId
        }
        
        axios.post(api.conexion + api.Forseti.sistema.audiencias.audienciasPorVerificar.ObtenAudienciaPorVerificar,
          peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
        ).then(respuesta => {
          if (respuesta.data.SiHayError) {
            console.log(respuesta);
            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            comun.SeEstaCargandoInformacion(false);
          } else {
            //CargarDatos de audiencia
            this.Audiencia = respuesta.data.AudienciaPorVerificar;
          }

          comun.SeEstaCargandoInformacion(false);
        })
          .catch(e => {
            console.log("No Hay Respuesta del Servidor", e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
      }
    }
  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Forseti/Audiencias/PanelDeAudienciasPorVerificar/EdicionYAsignacion.vue